export const TabRouteChangeMixin = {
    data() {
        return {
            activeTab: ''
        }
    },
    watch: {
        tab: {
            handler(tab) {
                // this condition with static string added for change name from Transaction tab to Receipts tab (on Transaction page) without refactoring route and tabs components.
                this.activeTab = tab === 'Transactions' ? 'Receipts' : tab;
            },
            immediate: true
        }
    }
};


// WEBPACK FOOTER //
// ./src/mixins/TabRouteChangeMixin.js